import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
  type AuthenticationResponseJSON,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
  type RegistrationResponseJSON,
} from '@simplewebauthn/browser';
import { api } from './api';

export function passkeysSupported(): boolean {
  return typeof window !== 'undefined' && browserSupportsWebAuthn();
}

/** Register a new passkey for the signed-in user. */
export async function registerPasskey(deviceName?: string): Promise<void> {
  const optionsJSON =
    (await api.auth.passkeys.registerOptions()) as PublicKeyCredentialCreationOptionsJSON;
  const response: RegistrationResponseJSON = await startRegistration({ optionsJSON });
  await api.auth.passkeys.registerVerify({ response, ...(deviceName ? { deviceName } : {}) });
}

/** Sign in with a passkey (discoverable credential when no email is given). */
export async function loginWithPasskey(email?: string): Promise<void> {
  const optionsJSON = (await api.auth.passkeys.loginOptions(
    email ? { email } : {},
  )) as PublicKeyCredentialRequestOptionsJSON;
  const response: AuthenticationResponseJSON = await startAuthentication({ optionsJSON });
  await api.auth.passkeys.loginVerify({ response, deviceName: describeDevice() });
}

/** Best-effort device label for the sessions/passkeys lists. */
export function describeDevice(): string {
  if (typeof navigator === 'undefined') return 'Web';
  const ua = navigator.userAgent;
  const os = /iPhone|iPad/.test(ua)
    ? 'iOS'
    : /Android/.test(ua)
      ? 'Android'
      : /Mac/.test(ua)
        ? 'macOS'
        : /Windows/.test(ua)
          ? 'Windows'
          : /Linux/.test(ua)
            ? 'Linux'
            : 'Web';
  const browser = /Firefox/.test(ua)
    ? 'Firefox'
    : /Edg\//.test(ua)
      ? 'Edge'
      : /Chrome/.test(ua)
        ? 'Chrome'
        : /Safari/.test(ua)
          ? 'Safari'
          : 'Browser';
  return `${browser} on ${os}`;
}
